import React from "react";
import {
  Grid,
  TextField,
  Typography,
  Paper,
  Switch,
  FormControlLabel,
  FormGroup,
  Button,
} from "@mui/material";
import QuestionType from "./QuestionType";

import request from "../../../../utilities/requests";

const YesNoQuestion = ({ questionData }) => {
  const [question, setQuestion] = React.useState(questionData);
  const [changed, setChanged] = React.useState(false);

  const handleValueChange = (field, value) => {
    question[field] = value;
    setQuestion({ ...question });
    setChanged(true);
  };

  const handleSave = async () => {
    const result = await request("matchmaking/question", "post", question);
    if (result.success) {
      setChanged(false);
    }
  };

  return (
    <Grid item>
      <Paper elevation={1} style={{ padding: 10 }}>
        <Grid container direction="row" alignItems="center" spacing={1}>
          <Grid item md={6} xs={12}>
            <TextField
              value={question?.question}
              variant="standard"
              size="small"
              fullWidth
              multiline
              maxRows={3}
              style={{ paddingRight: 10 }}
              onChange={(e) => handleValueChange('question', e.target.value)}
            />
          </Grid>
          <Grid item md={2} xs={6}>
            <QuestionType label="YesNo" />
          </Grid>
          <Grid item md={2} xs={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={question?.active}
                  onChange={() =>
                    handleValueChange("active", !question?.active)
                  }
                />
              }
              label="Active"
            />
          </Grid>
          {changed ? (
            <Grid item xs={12} md={2}>
              <Button variant="contained" onClick={handleSave}>
                Save
              </Button>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      </Paper>
    </Grid>
  );
};

export default YesNoQuestion;
